import * as ReactDOMClient from 'react-dom/client'
import {createStrategyRenderers} from './StrategyWidgets'

const renderers = createStrategyRenderers({
  href: '/strategies/periodic-coupons',
  title: 'Купоны на каждый день',
  description: 'Облигации российских компаний с распределённым календарём выплат.',
  annualYield: '+5% в год',
})

const registerPeriodicCouponsStrategyWidgets = () => {
  window.createRoot = (element) => ReactDOMClient.createRoot(element)
  window.renderPeriodicCouponsStrategyWidget = renderers.renderPerformance
  window.renderPeriodicCouponsStrategyStatisticsWidget = renderers.renderStatistic
  window.renderPeriodicCouponsStrategyPortfolioWidget = renderers.renderPortfolio
}

export {registerPeriodicCouponsStrategyWidgets}
